module.exports = __webpack_public_path__ + "fonts/open-sans-regular.eot";